import React from "react";
import {
  CreateFertigation,
  CropStageDetails,
  Fertigation,
  Home,
  NoPlot,
  Plot,
  PlotChart,
  Spray,
  Unauthorized,
  NutrientReportHistory,
  ViewFertigationReport,
  OrgHome,
  OrgCropStageDetails,
  AddActivity,
} from "../pages";
import { BrowserRouter, Routes as BRoutes, Route } from "react-router-dom";
import SensorsScreen from "../pages/sensors";
import SearchPlotsScreen from "../pages/search-plots";
import OrgPlotChart from "../pages/orgPlotChart";
import DiseaseSensorsScreen from "../pages/disease-sensors";
import PestSensorsScreen from "../pages/pest-sensors";
import CalendarScreen from "../pages/calendar";
import OthersScreen from "../pages/others";
import Notification from "../pages/notifications";
import AddCrop from "../pages/addCrop";
import Tickets from "../pages/tickets";
import Weather from "../pages/weather";
import { RouteErrorBoundary } from "../components/common/ErrorBoundary";

export enum Routes {
  "fertigation" = "/plot/:plotId/fertigation",
  "orgFertigation" = "/:orgId/plot/:plotId/fertigation",
  "createfertigation" = "/plot/:plotId/fertigation/create",
  "fertigationHistory" = "/plot/:plotId/fertigation/history",
  "viewFertigationReport" = "/plot/:plotId/fertigation/report",
  "cropStageDetails" = "/plot/:plotId/crop-stage-details",
  "orgCropStageDetails" = "/:orgId/plot/:plotId/crop-stage-details",
  "home" = "/home",
  "orgHome" = "/:orgId/home",
  "noPlot" = "/no-plot",
  "plot" = "/plot/:plotId",
  "unauthorized" = "/",
  "plotChart" = "/plot/:plotId/:sensor",
  "orgPlotChart" = "/:orgId/plot/:plotId/:sensor",
  "spray" = "/plot/:plotId/spray",
  "orgSpray" = "/:orgId/plot/:plotId/spray",
  "sensors" = "/:orgId/plot/:plotId/sensors",
  "diseaseSensors" = "/:orgId/plot/:plotId/disease-sensors",
  "pestSensors" = "/:orgId/plot/:plotId/pest-sensors",
  "searchPlots" = "/:orgId/searchPlots",
  "calendar" = "/:orgId/plot/:plotId/calendar",
  "others" = "/:orgId/:plotId/others",
  "notifications"="/:orgId/plot/:plotId/notifications",
  "tickets"="/:orgId/:plotId/tickets",
  "addActivity" = "/:orgId/plot/:plotId/addActivity",
  "addCrop" = "/:plotId/addCrop",
  "weather" = "/:plotId/weather"
}

const Router = () => {
  return (
    <BrowserRouter>
      <RouteErrorBoundary>
        <BRoutes>
          <Route path={Routes.orgHome} element={<OrgHome />} />
          <Route path={Routes.home} element={<Home />} />
          <Route path={Routes.noPlot} element={<NoPlot />} />
          <Route index path={Routes.unauthorized} element={<Unauthorized />} />
          <Route path={Routes.plot} element={<Plot />} />
          <Route path={Routes.plotChart} element={<PlotChart />} />
          <Route path={Routes.orgPlotChart} element={<OrgPlotChart />} />
          <Route path={Routes.fertigation} element={<Fertigation />} />
          <Route path={Routes.orgFertigation} element={<Fertigation />} />
          <Route
            path={Routes.createfertigation}
            element={<CreateFertigation />}
          />
          <Route path={Routes.spray} element={<Spray />} />
          <Route
            path={Routes.orgCropStageDetails}
            element={<OrgCropStageDetails />}
          />
          <Route path={Routes.cropStageDetails} element={<CropStageDetails />} />
          <Route path={Routes.spray} element={<Spray />} />
          <Route path={Routes.orgSpray} element={<Spray />} />
          <Route
            path={Routes.fertigationHistory}
            element={<NutrientReportHistory />}
          />
          <Route
            path={Routes.viewFertigationReport}
            element={<ViewFertigationReport />}
          />
          <Route path={Routes.sensors} element={<SensorsScreen />} />
          <Route path={Routes.searchPlots} element={<SearchPlotsScreen />} />
        DiseaseSensorsScreen
          <Route
            path={Routes.diseaseSensors}
            element={<DiseaseSensorsScreen />}
          />
          <Route path={Routes.pestSensors} element={<PestSensorsScreen />} />
          <Route path={Routes.calendar} element={<CalendarScreen />} />
          <Route path={Routes.others} element={<OthersScreen />} />
          <Route path={Routes.notifications} element={<Notification/>} />
          <Route path={Routes.tickets} element={<Tickets/>} />
          <Route path={Routes.addActivity} element={<AddActivity />} />
          <Route path={Routes.notifications} element={<Notification />} />
          <Route path={Routes.addCrop} element={<AddCrop />} />  
          <Route path={Routes.weather} element={<Weather />} />        
        </BRoutes>
      </RouteErrorBoundary>
    </BrowserRouter>
  );
};

export default Router;